<template>
  <div class="import-result">
    <Modal
      v-model="show"
      :width="80"
      title="提示"
      @on-visible-change="onVisibleChange"
    >
      <div class="content">
        <header class="text-align_center">
          <Icon type="md-checkmark-circle" size="50" color="#49bc19"></Icon>
          <h2>{{ titleText }}发起成功，请耐心等待系统处理结果！</h2>
          <p class="color-gray">可关闭当前页面，继续操作。</p>
        </header>
        <p class="flex align-items" style="margin: 10px 0">
          订单总数：<span style="margin-right: 8px; font-weight: bold">{{
            count.total
          }}</span>
          处理成功订单：<span
            class="color-blue"
            style="margin-right: 8px; font-weight: bold"
          >{{ count.subTaskSuccessNum }}</span>
          待处理订单：<span
            class="color-red"
            style="margin-right: 8px; font-weight: bold"
          >{{ count.subTaskWaitNum }}</span>
          处理失败订单：<span
            class="color-orange"
            style="margin-right: 8px; font-weight: bold"
          >
            {{ count.subTaskFailNum }}</span>
          <Spin v-show="loading">
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
          </Spin>
        </p>
        <div class="table">
          <Table
            :columns="tableColumns"
            :data="tableData"
            :loading="tableLoading"
            border
          >
            <template slot="procSts" slot-scope="{ row }">
              <span :class="[procStsClassObj[+row.procSts]]">{{
                row.procNameSts
              }}</span>
            </template>
            <template slot="remark" slot-scope="{ row }">
              <span class="color-red">{{ row.remark }}</span>
            </template>
            <template slot="reqMaterialType" slot-scope="{ row }">
              <span>{{ +row.reqMaterialType===1?'是':+row.reqMaterialType===0 ?'否':row.reqMaterialType }}</span>
            </template>
          </Table>
        </div>
      </div>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          show-sizer
          show-total
          show-elevator
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          @on-change="handlePageChange"
          @on-page-size-change="onPageSizeChange"
        ></Page>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="show = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import orderCenterApi from '@/request/orderCenter/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import timer from '@/utils/timer.js';
import axios from 'axios';
import { mapMutations } from 'vuex';
export default {
  props: {
    taskId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    titleText: {
      type: String,
      default: '订单导入'
    },
    fromType: {
      type: String,
      default: ''
    },
    showGetMainTask: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100, 500], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0

      },
      loading: false,
      tableLoading: false,
      show: false,
      tableColumns: [
        key('课程商品ID', 'classroomId', tableColumnsWidth.type4),
        key('课程商品名称', 'classroomName', tableColumnsWidth.type4),
        key('课程提供方', 'orgName', tableColumnsWidth.type4),
        key('学生姓名', 'studentName', tableColumnsWidth.type4),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type2),
        key('家长手机号码', 'phoneNo', tableColumnsWidth.type3),
        slot('是否含材料费', 'reqMaterialType', tableColumnsWidth.type9, { align: 'center' }),
        key('材料费名称', 'materialName', tableColumnsWidth.type4),
        slot('订单状态', 'procSts', tableColumnsWidth.type2),
        slot('备注', 'remark', tableColumnsWidth.type4)
      ],
      tableData: [],
      count: {
        total: 0,
        subTaskSuccessNum: 0,
        subTaskFailNum: 0,
        subTaskWaitNum: 0
      },
      returnThreshold: 0,
      procStsClassObj: {
        0: 'color-blue',
        1: 'color-green',
        2: 'color-blue',
        3: 'color-red'
      },
      source: null,
      mainSource: null,
      countSource: null,
      procStsObj: {
        0: '创建中',
        1: '创建成功',
        2: '创建中',
        3: '创建失败'
      } // 0-待执行 1-完成 2-进行中 3-失败
      // reqKey: 0, // 统计接口调用次数
      // reqListKey: 0, // 列表接口调用次数
    };
  },
  created() {

  },
  destroyed() {
    this.batchOrderSubTask ? this.batchOrderSubTask.cancel('取消请求') : '';
    this.handleTaskProgressCancel();
    timer.clearTimer('importMainTaskProgress');
  },
  methods: {
    ...mapMutations([
      'DELETE_CACHEROUTE'
    ]),
    onVisibleChange(status) {
      if (this.fromType === 'createOrder' && !status) {
        this.batchOrderSubTask ? this.batchOrderSubTask.cancel('取消请求') : '';
        this.handleTaskProgressCancel();
        timer.clearTimer('importMainTaskProgress');
        this.$emit('closeModal');
        return;
      }
      if (!status) {
        this.batchOrderSubTask ? this.batchOrderSubTask.cancel('取消请求') : '';
        this.handleTaskProgressCancel();
        this.DELETE_CACHEROUTE('OrderCenterCourseOrderTable');
        timer.clearTimer('importMainTaskProgress');
        this.$router.push({ name: 'orderCenter_order_orderTable' });
      }
    },
    handleShow(successCount) {
      this.show = true;
      this.returnThreshold = 0;
      // this.reqKey = 0
      // this.reqListKey = 0
      this.count.total = successCount;
      this.loading = true;
      this.tableLoading = true;
      setTimeout(() => {
        this.showGetMainTask ? this.getMainTaskProgress() : (this.getQrySubTaskProgress(), this.getDivideTaskStatusPage());
      }, 300);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.handleTaskProgressCancel();
      this.getDivideTaskStatusPage();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.handleTaskProgressCancel();
      this.getDivideTaskStatusPage();
    },
    // 取消任务
    handleTaskProgressCancel() {
      this.source ? this.source.cancel('取消请求') : '';
      this.mainSource ? this.source.cancel('取消请求') : '';
    },
    refreshData(list) {
      list.forEach(item => {
        const key = this.tableData.findIndex(item_1 => { return item_1.batchId == item.batchId; });
        this.tableData[key]['procSts'] = item.prcSts;
        this.tableData[key]['remark'] = item.msg;
        this.tableData[key]['procNameSts'] = this.procStsObj[Number(item.prcSts)];
      });
      this.tableData = Object.assign([], this.tableData);
    },
    // 检测任务是否已完成了，
    checkTotal() {
      // 任务完成了，不可再发起
      if (this.count.total == this.count.subTaskFailNum + this.count.subTaskSuccessNum) {
        return false;
      }
      return true;
    },
    // 获取主任务的进度
    async getMainTaskProgress() {
      if (!this.taskId) {
        return;
      }
      const params = {
        batchIds: [this.taskId], // 任务id
        returnThreshold: 100 // 默认全部完成返回，百分比
      };
      this.mainSource = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.mainSource.token);
      this.mainSource = null;
      timer.clearTimer('importMainTaskProgress');
      if (res.status === 200) {
        if (res.message.length) {
          const data = res.message[0];
          if (data.prcSts == 0 || data.prcSts == 2) {
            // 创建中
            this.$nextTick(() => {
              timer.addTimer('importMainTaskProgress', this.getMainTaskProgress, 4000);
            });
          } else if (data.prcSts == 3) {
            // 创建失败

            this.$Modal.warning({
              title: '提示',
              content: data.msg,
              onOk: () => {
                this.$router.go(0);
              }
            });
          } else if (data.prcSts == 1) {
            // 创建成功

            this.getQrySubTaskProgress();
            this.getDivideTaskStatusPage();
          }
        }
      } else {
        this.$Modal.warning({
          title: '提示',
          content: res.error,
          onOk: () => {
            this.$router.go(0);
          }
        });
      }
    },
    // 获取任务的进度
    async getTaskProgress(batchIds) {
      if (batchIds.length === 0) {
        return;
      }
      const params = {
        batchIds, // 任务id
        returnThreshold: 10 // 默认全部完成返回，百分比
      };
      this.source = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.source.token);
      this.source = null;
      if (res.status === 200) {
        this.refreshData(res.message);
      }
    },
    // 通过父级任务id获取该任务完成情况
    async getDivideTaskStatusPage() {
      this.tableLoading = true;
      const res = await courseSchedulCenter.getTaskStatusListApi({
        upBatchIds: [this.taskId],
        schoolIdList: [this.schoolId],
        // busiCode: 7, //  业务编码  7-后台导入订单
        exeFlag: 1,
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      });
      this.tableLoading = false;
      if (res.status === 200) {
        const branchIds = [];
        this.tableData = res.message.list.map(item => {
          if ([0, 2].includes(item.batchProcData.procSts)) {
            branchIds.push(item.batchProcData.batchId);
          }
          return {
            ...item.properties,
            batchId: item.batchProcData.batchId,
            procSts: item.batchProcData.procSts,
            remark: item.batchProcData.lineData3,
            procNameSts: this.procStsObj[Number(item.batchProcData.procSts)]
          };
        });

        // if (res.message.list.length > 0) {
        //   timer.clearTimer('importResultList');
        // } else {
        //   this.reqListKey++
        // }
        this.pageInfo.total = Number(res.message.total);
        if (branchIds.length > 0) {
          this.getTaskProgress(branchIds);
        }
      } else {
        // this.reqListKey++
      }
      // if (this.reqListKey >= 10) {
      //   timer.clearTimer('importResultList');
      // }
    },
    // 检查 列表数据是否还有创建中
    checkListTask() {
      const branchIds = [];
      this.tableData.forEach(item => {
        if ([0, 2].includes(item.procSts)) {
          branchIds.push(item.batchId);
        }
      });
      if (branchIds.length > 0) {
        this.getTaskProgress(branchIds);
      }
    },
    // 获取任务状态统计
    async getQrySubTaskProgress() {
      this.countSource = axios.CancelToken.source();
      this.returnThreshold = this.returnThreshold < 100 ? this.returnThreshold + 10 : 100;
      const res = await orderCenterApi.getQrySubTaskProgress({
        taskId: this.taskId,
        returnThreshold: this.returnThreshold,
        beforeFinNum: this.count.subTaskSuccessNum + this.count.subTaskFailNum
      });
      this.countSource = '';
      if (res.status == 200) {
        // this.reqKey = 0
        for (const k in res.message) {
          this.count[k] = res.message[k] ? Number(res.message[k]) : 0;
        }
        this.count.subTaskWaitNum = this.count.total - this.count.subTaskSuccessNum - this.count.subTaskFailNum;

        if (this.checkTotal()) {
          this.getQrySubTaskProgress();
        } else {
          this.loading = false;
          this.checkListTask();
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
